import Vue from 'vue'
import { mapActions, mapState } from 'vuex'
import Alerts from '../general/alerts'
import VueSweetAlert from 'vue-sweetalert'
Vue.use(VueSweetAlert)


/**
 * Update VeeValidate ErrorBag for Backend Errors
 */
Vue.mixin({
    components: {
        Alerts
    },
    computed: mapState([ 'messages', 'fetching' ]),
    methods: {
        /**
        * Map the actions from Vuex to this component.
        * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator
        */
        ...mapActions(['setMessage', 'resetMessages']),

        updateErrors($response) {
        
                let backendErrors = $response.response.data.errors;

                for (let index in backendErrors) {
                this.errors.add(index, backendErrors[index][0])
            }    
           
        },
    }
});



// WEBPACK FOOTER //
// ./src/components/mixins/validationErrors.js